'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactModal = require('react-modal');var _reactModal2 = _interopRequireDefault(_reactModal);
var _PublishProcessOverlay = require('./PublishProcessOverlay.scss');var _PublishProcessOverlay2 = _interopRequireDefault(_PublishProcessOverlay);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var PublishProcessOverlay = function PublishProcessOverlay(props) {return (
    _react2.default.createElement(_reactModal2.default, _extends({},
      props, {
        className: _PublishProcessOverlay2.default.processModal,
        overlayClassName: _PublishProcessOverlay2.default.processOverlay,
        shouldCloseOnOverlayClick: false,
        shouldCloseOnEsc: false,
        contentLabel: 'OnMap Publish Process Overlay' }),

      _react2.default.createElement('div', { className: _PublishProcessOverlay2.default.content },
        _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }),
        _react2.default.createElement('div', { className: _PublishProcessOverlay2.default.title },
          props.translate('processOverlayTitle')),

        _react2.default.createElement('div', { className: _PublishProcessOverlay2.default.subtitle },
          props.translate('processOverlaySubtitle')))));};





PublishProcessOverlay.propTypes = {
  translate: _propTypes2.default.func };exports.default =


PublishProcessOverlay;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PublishProcessOverlay/PublishProcessOverlay.js
// module id = 2865
// module chunks = 0